import React, { useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";

import { useNavigate } from "react-router-dom";

import ContactService from "../../../services/contact/contact.service";
import { showErrorToaster } from "../../../components/toaster/error";
import DataTableDisplay from "../../../components/tableMission";
import ReactPaginate from "react-paginate";
import ContactResponsiveCards from "../contactResponsiveCards";

const contactService = new ContactService();

function ContactListe() {
  const [contacts, setContact] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await contactService?.getAllContact();
      setContact(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const columnsContacts = [
    {
      name: "Nom et Prénom",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.fullname != null && row?.fullname}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.email != null && row?.email}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Message",
      selector: (row) => (
        <div className="table-text">{row?.message != null && row?.message}</div>
      ),
      hide: "md",
      sortable: true,
    },
  ];
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3; // Adjust this number as needed

  // Calculate the offset
  const offset = currentPage * itemsPerPage;

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3>Contacts liste</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-0 my-md-5  justify-content-center align-items-center"></div>
        ) : (
          <div className="my-5 py-2">
            {isMobile > 599 ? (
              <DataTableDisplay columns={columnsContacts} data={contacts} />
            ) : (
              <>
                {contacts.map((item) => (
                  <ContactResponsiveCards
                    key={item.id} // Ensure the key is unique for each item
                    handleStatus={""}
                    blog={item}
                    loadData={loadData}
                  />
                ))}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={Math.ceil(contacts.length / itemsPerPage)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default ContactListe;
